import { render, staticRenderFns } from "./ServicesSlider.vue?vue&type=template&id=dfdfb9a0&scoped=true&"
import script from "./ServicesSlider.vue?vue&type=script&lang=ts&"
export * from "./ServicesSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesSlider.vue?vue&type=style&index=0&id=dfdfb9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdfb9a0",
  null
  
)

export default component.exports